import React from 'react'
import { ChipField, ChipFieldProps } from 'react-admin'
import LocalizedFieldGeneric from './LocalizedField'

type Props = Omit<ChipFieldProps, 'children' | 'source'> & {
  source: string
  children: React.ReactElement
}

type LocalizedChipFieldProps = Omit<Props, 'children'>

const LocalizedField = (props: Props) => LocalizedFieldGeneric(props)

const LocalizedChipField: React.FC<LocalizedChipFieldProps> = (props) => (
  <LocalizedField {...props}>
    <ChipField />
  </LocalizedField>
)

export default LocalizedChipField
